import React from "react"

interface PriceProps {
  value: number
  size: "small" | "medium"
}

export function Price({ value, size }: PriceProps) {
  const wrapperClassNames = {
    small: "inline-flex gap-2 items-center",
    medium: "inline-flex gap-4 items-center",
  }

  const logoWrapperClassNames = {
    small: "p-1 md:p-2 bg-gray-50 rounded-full",
    medium: "p-3 bg-gray-50 rounded-full",
  }

  const logoClassNames = {
    small: "w-2 h-2 md:w-4 md:h-4",
    medium: "w-6 h-6",
  }

  const textClassNames = {
    small: "text-xs antialiased md:text-base text-gray-900",
    medium: "text-2xl antialiased md:text-5xl text-gray-900",
  }

  return (
    <div className={wrapperClassNames[size]}>
      <div className={logoWrapperClassNames[size]}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 90 90"
          xmlSpace="preserve"
          className={logoClassNames[size]}
        >
          <path d="M72.2 4.6 53.4 32.5c-1.3 1.9 1.2 4.2 3 2.6L74.9 19c.5-.4 1.2-.1 1.2.6v50.3c0 .7-.9 1-1.3.5l-56-67C17 1.2 14.4 0 11.5 0h-2C4.3 0 0 4.3 0 9.6v70.8C0 85.7 4.3 90 9.6 90c3.3 0 6.4-1.7 8.2-4.6l18.8-27.9c1.3-1.9-1.2-4.2-3-2.6l-18.5 16c-.5.4-1.2.1-1.2-.6V20.1c0-.7.9-1 1.3-.5l56 67c1.8 2.2 4.5 3.4 7.3 3.4h2c5.3 0 9.6-4.3 9.6-9.6V9.6c0-5.3-4.3-9.6-9.6-9.6-3.4 0-6.5 1.7-8.3 4.6z" />
        </svg>
      </div>
      <span className={textClassNames[size]}>{value}</span>
    </div>
  )
}
